import React from 'react';

const SkinTypeStep = ({ answers, setAnswers }) => {
  const options = ['نرمال', 'چرب', 'خشک', 'مختلط', 'حساس', 'آکنه‌دار'];

  // Toggle skin type selection for multi-select
  const handleToggle = (type) => {
    const current = answers.skinType || [];
    const updated = current.includes(type)
      ? current.filter(t => t !== type)
      : [...current, type];
    setAnswers({ ...answers, skinType: updated });
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        لطفا ویژگی‌های نوع پوست خود را انتخاب کنید (چند گزینه قابل انتخاب است)
      </h2>
      <div className="grid grid-cols-3 gap-4">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => handleToggle(option)}
            className={`p-4 rounded-lg border-2 transition-transform duration-200 ${
              (answers.skinType || []).includes(option)
                ? 'border-black bg-black text-white'
                : 'border-gray-300 bg-white text-gray-800 hover:bg-gray-50'
            } transform hover:scale-105 focus:outline-none`}
          >
            <span className="text-sm font-medium">{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SkinTypeStep; 